import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../components/layouts/dashboard'
import UnauthorizedPage from '../errors/unauthorized'
import { useSelector } from 'react-redux'
import { Card } from '../../components/card'
import PayslipSVG from '../../assets/svg/payslip.svg'
import DepartmentSVG from '../../assets/svg/department-widget-icon.svg'

const AdminManagementHomePage = () => {
  const { user } = useSelector((state) => state.userSlice)
  const [unauthorized, setUnauthorized] = useState(false)

  useEffect(() => {
    if (user) {
      if (user?.company?.hr_subscription !== 1) {
        setUnauthorized(true)
      }
    }
  }, [user])

  const adminCards = [
    {
      title: 'Employees',
      path: `/employees`,
      icon: DepartmentSVG,
    },
    {
      title: 'Salaries',
      path: `/salaries`,
      icon: PayslipSVG,
    },
  ]

  let isAdmin =
    user?.company?.employee?.permission_employee_read === 1 ||
    user?.company?.employee?.permission_employee_write === 1 ||
    user?.company?.employee?.permission_salary_read === 1 ||
    user?.company?.employee?.permission_salary_write === 1

  return (
    <DashboardLayout title='Admin Management'>
      {unauthorized ? (
        <UnauthorizedPage />
      ) : (
        <main className='flex flex-col gap-2.5'>
          <div className='flex flex-col'>
            <span className='header-3'> Welcome {user?.first_name},</span>
            <span className='text-[14px] text-gray-500'>
              You have been assigned as an admin. <br /> Changes/Updates made
              here will be approved by the senior HR
            </span>
          </div>
          {user?.status === 1 && user.company_id && isAdmin && (
            <div
              id='dashboard-overview'
              className='grid md:grid-cols-4 lg:grid-cols-4 grid-cols-2 gap-4 w-full content-center justify-items-center justify-self-center mt-8'
            >
              {adminCards.map((item, index) => (
                <Card
                  key={index}
                  title={item.title}
                  path={item.path}
                  subtitle={item.value}
                  icon={item.icon}
                />
              ))}
            </div>
          )}
        </main>
      )}
    </DashboardLayout>
  )
}

export default AdminManagementHomePage
